import { render, staticRenderFns } from "./UiContainer.vue?vue&type=template&id=e684e6f2&scoped=true"
import script from "./UiContainer.vue?vue&type=script&lang=js"
export * from "./UiContainer.vue?vue&type=script&lang=js"
import style0 from "./UiContainer.vue?vue&type=style&index=0&id=e684e6f2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e684e6f2",
  null
  
)

export default component.exports